export default "__VITE_ASSET__B5qdth6z__"